export const RAILSIGHT_STATUS = {
  // Container Trace Failures
  RAILSIGHT_ENABLED:
    'Rail Enabled',
  RAILSIGHT_DISABLED:
    'Rail Disabled'
};
